module.exports = __webpack_public_path__ + "static/ETCH_BAG-7b720fe42e31fbcd06a968aac07ff1b5.gif";